
export interface WarningData {
  type: string;
  pnr: string;
  path: string;
  timestamp: number;
}

const channel = new BroadcastChannel('crosstab-warning');

sessionStorage.myCurrentBooking = undefined;

export function sendCrosstabWarning(data: WarningData) {
  if (data.type === 'mmb') {
    sessionStorage.myCurrentBooking = data.pnr;
  }
  channel.postMessage(data);
}

export function receiveCrosstabWarning(callback: (data: WarningData, myBooking?: string) => void) {
  channel.onmessage = (event) => {
    if (event.data) {
      callback(event.data, sessionStorage.myCurrentBooking);
    }
  };
}

export function closeCrosstabWarning() {
  channel.close();
}